<!-- This component can take both from a local list, say in $store, or directly from a controller -->




<!-- fields is an array of objects:
    {
        label:'מחיר',
        name: 'price'
        isNumber (boolean)
        defaultValue (what a new row starts with)
    } -->


<template>
    <div>
        <Modal :title="title"
               :noClose="true"
               :xlarge="true"
               ref="superQuickEditModal"
               :hideFooter="true">

            <template v-slot:body>
                לחצו על כל שדה בטבלה כדי לערוך אותו, או על כפתור המחיקה על מנת להסיר את השורה. לבסוף לחצו על כפתור "שמור
                שינויים" או ביטול.

                <br>
                <br>


                <table class="superQuickEditTable">

                    <tr style="text-align: center;">
                        <th v-for="field in fields"
                            style="font-weight:normal">
                            {{ field.label }}
                        </th>
                    </tr>

                    <tr v-for="item in localList"
                        v-if="!item.hidden">

                        <td v-for="field in fields">


                            <div v-if="field.options && field.optionsTagFunction">

                                <Multiselect @input="addToChangedList(item)"
                                             style="min-width:220px"
                                             v-model="item[field.name]"
                                             deselect-label=""
                                             :taggable="true"
                                             placeholder=""
                                             selectLabel=""
                                             @tag="(newTag) => field.optionsTagFunction(newTag, field.options, field.name, item)"
                                             track-by="value"
                                             label="name"
                                             noResult=" נמצאה התאמה"
                                             tagPlaceholder="הקישו אנטר להוספה"
                                             selectedLabel=""
                                             :allow-empty="false"
                                             :showNoOptions="false"
                                             :options="field.options.filter(x => !x.hidden)">

                                    <template slot="noResult">לא נמצאו תוצאות</template>
                                </Multiselect>

                            </div>
                            <div v-else-if="field.options && !field.optionsTagFunction">

                                <Multiselect @select="addToChangedList(item)"
                                             style="width:220px"
                                             v-model="item[field.name]"
                                             deselect-label=""
                                             placeholder=""
                                             selectLabel=""
                                             track-by="value"
                                             noResult="לא נמצאה התאמה"
                                             label="name"
                                             selectedLabel=""
                                             :allow-empty="false"
                                             :showNoOptions="false"
                                             :options="field.options.filter(x => !x.hidden)">

                                    <template slot="noResult">לא נמצאו תוצאות</template>
                                </Multiselect>

                            </div>

                            <div v-else-if="field.isColor">

                                <input type="color"
                                       v-model="item[field.name]"
                                       @change="addToChangedList(item)"
                                       style="width: 30px; height: 30px;">

                            </div>

                            <div v-else-if="field.isCheckbox"
                                 @click="addToChangedList(item)"
                                 style="text-align: center;">

                                <label style="user-select: none;cursor:pointer"
                                       @click="item[field.name] = !item[field.name]">


                                    <span style="position:relative;top:1px;"
                                          class="planup-checkbox planup-checkbox-red"
                                          :class="{ checked: item[field.name] }">
                                        <i class="fa fa-check"></i>
                                    </span>

                                    <!-- <span v-if="item[field.name]">
                                        {{ field.markedText }}
                                    </span> -->



                                </label>

                            </div>


                            <div v-else-if="field.isGoogleCalendarColorId">

                                <Multiselect @select="addToChangedList(item)"
                                             style="width:220px"
                                             v-model="item.googleCalendarColorId"
                                             deselect-label=""
                                             placeholder=""
                                             selectLabel=""
                                             noResult="לא נמצאה התאמה"
                                             selectedLabel=""
                                             :allow-empty="false"
                                             :showNoOptions="false"
                                             :options="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]">




                                    <template #singleLabel="props">


                                        <i class="fa-regular fa-circle"
                                           :style="{ color: $store.state.googleColorIds[props.option].color, position: 'relative', top: '1px' }"></i>

                                        {{ $store.state.googleColorIds[props.option].name }}

                                    </template>



                                    <template #option="props">
                                        <i class="fa-regular fa-circle"
                                           :style="{ color: $store.state.googleColorIds[props.option].color, position: 'relative', top: '1px' }"></i>

                                        {{ $store.state.googleColorIds[props.option].name }}

                                    </template>




                                    <template slot="noResult">לא נמצאו תוצאות</template>
                                </Multiselect>

                            </div>

                            <div v-else-if="field.isCalendarSyncMode">

                                <Multiselect @select="addToChangedList(item)"
                                             style="width:180px"
                                             v-model="item.calendarSyncMode"
                                             deselect-label=""
                                             placeholder=""
                                             selectLabel=""
                                             noResult="לא נמצאה התאמה"
                                             selectedLabel=""
                                             :allow-empty="false"
                                             :showNoOptions="false"
                                             track-by="value"
                                             label="name"
                                             :options="calendarSyncModeOptions">
                                    <template slot="noResult">לא נמצאו תוצאות</template>
                                </Multiselect>

                            </div>



                            <div v-else-if="field.isPic">
                                <img onerror="this.remove()"
                                     :src="'https://planup-il.s3.eu-central-1.amazonaws.com/' + item[field.name]"
                                     class="quickSuperEditPic">
                            </div>

                            <div v-else>
                                <input class="quickSuperEditTextInput form-control"
                                       :type="field.isNumber ? 'number' : 'text'"
                                       v-model="item[field.name]"
                                       @change="addToChangedList(item)"
                                       @blur="field.blurFunction ? field.blurFunction(item) && addToChangedList(item) : () => { }"
                                       placeholder="(ללא)">

                            </div>

                        </td>

                        <td style="width:46px;text-align: center;">
                            <i style="color:rgb(119, 119, 119);"
                               @click="deleteItem(item)"
                               class="fa-regular fa-trash-can redHover"></i>
                        </td>

                    </tr>

                </table>



                <span @click="addNewItemToLocalList()"
                      style="color: rgb(141, 99, 218); cursor: pointer; font-size: 25px;position: relative; top: 3px;">
                    <i class="fa-solid fa-plus"></i>
                </span>


                <br>
                <br>

                <div class="pull-right">
                    <button class="btn btn-light"
                            @click="$refs.superQuickEditModal.hide()">
                        ביטול
                    </button>
                    &nbsp;
                    <button class="btn btn-primary"
                            @click="saveChanges()">
                        שמור שינויים
                    </button>


                </div>


            </template>

        </Modal>
    </div>
</template>
<script>

import Multiselect from "vue-multiselect";

export default {
    name: 'QuickSuperEdit',
    props: ['title', 'listName', 'fields', 'controller', 'bulkSaveFilterFunction', 'filterListFunction'],
    data() {
        return {
            localList: [],
            changedList: [],
            calendarSyncModeOptions: [
                { value: 'sync', name: 'סנכרון יומן' },
                { value: 'attendee', name: 'משתתף באירוע' }
            ]
        }
    },

    computed: {
        // countItems() - lets us reload our list if the page loads before ajax of loading the $store.state completes
        countItems() {

            if (!this.$store.state[this.listName])
                return 0;

            return this.$store.state[this.listName].length;
        }
    },

    watch: {
        countItems() {
            this.initList();
        }
    },
    methods: {

        deleteItem(item) {

            // $set - item-group rows arrive without a 'hidden' property, so plain assignment isn't reactive
            this.$set(item, 'hidden', true);
            this.addToChangedList(item);
        },

        addNewItemToLocalList() {


            let checkboxes = this.fields.filter(x => x.isCheckbox);

            let newItem = {};   //this is so cool, that we use the reference of it
            checkboxes.forEach(x => newItem[x.name] = false);

            //a field may say what a new row starts with (the color of a new סטטוס פגישה)
            this.fields.filter(x => 'defaultValue' in x).forEach(x => newItem[x.name] = x.defaultValue);

            this.localList.push(newItem);
            this.changedList.push(newItem);
        },

        saveChanges() {

            this.$swal({
                title: 'האם לשמור את השינויים שביצעתם?',
                showCancelButton: true,
                confirmButtonText: 'שמור',
                cancelButtonText: 'ביטול',
                confirmButtonColor: '#ab8ce4',
            }).then(() => {
                this.$handlers.listsHandler.bulkSave(this.changedList, this.listName, this.controller, this.bulkSaveFilterFunction, () => {
                    this.$emit('updateList');
                    this.$refs.superQuickEditModal.hide();
                })
            })

        },

        addToChangedList(item) {

            if (this.changedList.indexOf(item) == -1)
                this.changedList.push(item);

        },

        initList() {

            let localList;


            if (this.listName) {

                localList = this.countItems ? deepCopy(this.$store.state[this.listName].filter(x => !x.hidden)) : [];

            }


            let filterListFunction = this.filterListFunction;


            //take from controller if we don't have list name
            if (!this.listName) {

                this.$handlers.listsHandler.getList(this.controller, (response) => {

                    localList = filterListFunction ? response.data.map(i => filterListFunction(i)) : response.data;

                })

            }

            localList.sort((a, b) => (a.name || '').localeCompare(b.name || ''));

            // Initialize crew member specific fields (only for crew members list)
            if (this.listName === 'crewMembers') {
                localList.forEach(item => {
                    // Initialize calendarSyncMode to 'sync' option object if not set
                    if (item.calendarSyncMode === null || item.calendarSyncMode === undefined) {
                        item.calendarSyncMode = this.calendarSyncModeOptions[0]; // Default to 'sync'
                    } else if (typeof item.calendarSyncMode === 'string') {
                        // Convert string value to option object
                        item.calendarSyncMode = this.calendarSyncModeOptions.find(o => o.value === item.calendarSyncMode) || this.calendarSyncModeOptions[0];
                    }
                    // Initialize showPriceOnCalendar to true if not set
                    if (item.showPriceOnCalendar === null || item.showPriceOnCalendar === undefined) {
                        item.showPriceOnCalendar = true;
                    }
                });
            }

            this.localList = localList;

        },

        show() {

            this.$refs.superQuickEditModal.show();
            this.initList();    //we kill unsaved changes
        },
    },

    components: { Multiselect }
}
</script>
<style>
.superQuickEditTable {
    width: 100%
}

.superQuickEditTable td {
    padding: 5px;
}
</style>